<div
  class="fixed top-5 right-5 z-[9999] max-w-sm transition-all duration-300 ease-in-out"
  [class.opacity-0]="!visible"
  [class.opacity-100]="visible"
  [class.translate-x-full]="!visible"
  [class.translate-x-0]="visible">
  <p-message
    *ngIf="visible && message"
    [severity]="message.severity"
    [text]="message.detail"
    [closable]="true"
    (onClose)="onClose()"
    class="mb-0 shadow-lg" />
</div>
